<template>
  <v-dialog persistent v-model="showremoverecipient" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Remove from channel
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          auto-select-first
          :items="deletionList"
          item-text="username"
          item-value="username"
          chips
          clear-icon="mdi-close-circle"
          hide-selected
          label="Select Account"
          class="ma-6"
          v-model="selectedRecipientToRemove"
        >
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="#78909c"
              class="white--text"
              v-on="on"
            >
              <v-icon left>mdi-coin</v-icon>
              <span v-text="item"></span>
            </v-chip>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closedialog()">
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          :disabled="!selectedRecipientToRemove"
          @click="submit()"
        >
          Remove
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RemoveRecipient",
  props: {
    showremoverecipient: Boolean,
    acls: Array,
    currentlySelectedAccount: String,
    channel: Object,
  },
  data() {
    return {
      selectedRecipientToRemove: undefined,
    };
  },
  computed: {
    deletionList: function() {
      const res = [];
      for (let recipient of this.channel.recipients) {
        res.push(recipient.username);
      }
      return res;
    },
  },
  methods: {
    closedialog() {
      this.$emit("closedialog");
    },
    async submit() {
      const data = {
        account: this.currentlySelectedAccount,
        recipient: this.selectedRecipientToRemove,
        channel_id: this.channel._id,
      };
      const res = await this.$store.dispatch("removeChannelRecipient", data);
      if (res.Error) {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `${res.Error}`,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Recipient ${this.selectedRecipientToRemove} has been removed from channel "${this.channel.conversation_name}"`,
        });
      }
      this.selectedRecipientToRemove = undefined;
      this.$emit("refreshconversations");
      this.$emit("closedialog");
    },
  },
};
</script>

<style></style>
